// @flow

import _ from 'lodash';
import React, { Component, type ComponentType, type Node } from 'react';

import { copyTextToClipboard } from '@zapier/common-utils';

import Button from 'app/common/components/Button';

type ClipboardButtonProps = {
  ChildComponent: ComponentType<Object>,
  label?: Node,
  labelError?: Node,
  labelSuccess?: Node,
  text: string,
  timeout?: number | null,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLElement>) => void,
};

type ClipboardButtonState = {
  label: Node,
};

class ClipboardButton extends Component<
  ClipboardButtonProps,
  ClipboardButtonState
> {
  static defaultProps = {
    ChildComponent: Button,
    label: 'Copy to clipboard',
    labelError: 'Couldn’t copy!',
    labelSuccess: 'Copied!',
    timeout: 3000,
  };

  state = { label: this.props.label };

  timeout: ?TimeoutID;

  updateContent = (didCopy: boolean) => {
    const { props } = this;
    const label = didCopy ? props.labelSuccess : props.labelError;
    this.setState({ label });
    if (this.props.timeout) {
      this.timeout = setTimeout(() => {
        this.setState({ label: props.label });
      }, this.props.timeout);
    }
  };

  copy = () => {
    return copyTextToClipboard(this.props.text);
  };

  onClick = (e: SyntheticEvent<HTMLElement>) => {
    e.preventDefault();
    const didCopy = this.copy();
    this.updateContent(didCopy);
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    const { ChildComponent, ...props } = this.props;
    return (
      <ChildComponent
        {..._.omit(props, 'label', 'labelError', 'labelSuccess')}
        onClick={this.onClick}
      >
        {this.state.label}
      </ChildComponent>
    );
  }
}

export default ClipboardButton;
